import { Button, SizeFittingTable } from '@/src/components/Antd';
import ModalHOC from '@/src/constrains/ModalHOC';
import React from 'react';
import styles from '../style.module.less';
import OtherAvailableCurrencyModal from './OtherAvailableCurrencyModal';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const OtherAvailableCurrencyTable = ({
  currencyOptions = [],
  currencyConfig = [],
  handleOnAddOtherCurrency,
  handleOnDeleteOtherCurrency,
  onEditCurrency,
  disabled,
}) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const [otherCurrencyModalVisible, setAddOtherCurrencyModalVisible] =
    React.useState<boolean>(false);
  const showAddOtherCurrencyModal = () => {
    setAddOtherCurrencyModalVisible(true);
  };
  // const [priceTierIndex, setPriceTierIndex] = React.useState<number>(-1);
  // const onPriceTierActionEditClick = (column, index) => {
  //   setPriceTierIndex(index);
  //   setAddOtherCurrencyModalVisible(true);
  // };
  const hideAddOtherCurrencyModal = () => {
    setAddOtherCurrencyModalVisible(false);
  };

  const onConfirm = (values) => {
    handleOnAddOtherCurrency(values);
    hideAddOtherCurrencyModal();
  };

  //currencyConfig delete
  const handleOnDelete = (uuid) => {
    handleOnDeleteOtherCurrency(uuid);
  };

  const priceTierColumns = [
    {
      title: 'No',
      key: 'index',
      dataIndex: 'index',
      default: true,
      width: 90,
      childGenerate: (_, record, index) => {
        return <div className={styles.tb}>{index + 1}.</div>;
      },
    },
    {
      title: getI18n('salesChannelCurrency.index.availableCurrency'),
      dataIndex: 'currencyCode',
      key: 'currencyCode',
      default: true,
      width: 200,
      align: 'center',
      textWrap: 'word-break',
      childGenerate: (text: string) => {
        return <div style={{ margin: '0 auto' }}>{text}</div>;
      },
    },
    disabled
      ? {}
      : {
          title: getI18n(
            'general.advancedFilters.commonStoreProductsWithTable.actions',
          ),
          default: true,
          optional: true,
          align: 'center',
          width: 1000,
          childGenerate: (_, record, index) => {
            const { uuid } = record;
            return (
              <div className={styles.action}>
                <span
                  className={styles.primary}
                  onClick={() => onEditCurrency(uuid)}>
                  {getI18n('salesChannelCurrency.index.editCurrencyFormat')}
                </span>
                <span
                  className={styles.danger}
                  onClick={() => {
                    handleOnDelete(uuid);
                  }}>
                  {getI18n('general.delete')}
                </span>
              </div>
            );
          },
        },
  ];
  return (
    <>
      {currencyConfig.length ? (
        <SizeFittingTable
          rowKey='uuid'
          pagination={false}
          id='SalesChannelSettingsOtherCurrency'
          className={styles.table}
          dataSource={currencyConfig}
          columns={priceTierColumns}
        />
      ) : (
        <></>
      )}
      {currencyOptions.length > 0 && (
        <>
          <Button
            type='primary'
            onClick={showAddOtherCurrencyModal}
            disabled={disabled}>
            {getI18n('salesChannelCurrency.index.addOtherAvailableCurrency')}
          </Button>
          <OtherAvailableCurrencyModal
            visible={otherCurrencyModalVisible}
            onConfirm={onConfirm}
            onCancel={hideAddOtherCurrencyModal}
            currencyOptions={currencyOptions}
          />
        </>
      )}
    </>
  );
};

export default ModalHOC(OtherAvailableCurrencyTable);
